<template>
  <div class="survey-grid-select-component">
    <div class="header">
      <div class="title">{{ desc }}</div>
      <span class="desc">最多可选{{ max }}个</span>
    </div>
    <div class="list">
      <div class="item"
           :class="{ 'active': handleItemStyle(item.key) }"
           v-for="(item, index) in list"
           :key="index"
           @click="handleGridItem(item.key, item.value)"
      >
        {{ item.value }}
      </div>
    </div>
    <div class="submit-btn ym-mw-component-fixed-max">
      <ym-button type="primary"
                 size="large"
                 round
                 :disabled="submitDisabled"
                 v-ym-report:[recordName]=""
                 @click="handleSubmit"
      >
        确定
      </ym-button>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';

  export default {
    name: 'SurveyInterestInfo',
    components: {
      'ym-button': Button,
    },
    props: {
      desc: {
        type: String,
        required: true,
      },
      max: {
        type: Number,
        required: true,
      },
      list: {
        type: Array,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      selectedKeyList: {
        type: Array,
        default() {
          return [];
        },
      },
      selectedValueList: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        keyList: this.selectedKeyList,
        valueList: this.selectedValueList,
      };
    },
    computed: {
      submitDisabled() {
        return this.keyList.length === 0;
      },
      recordName() {
        if (this.type === 'interest') return 'LEARNING_INFO_STEP_2_CONFIRM_CLICK';
        return 'LEARNING_INFO_STEP_3_CONFIRM_CLICK';
      },
    },
    watch: {
      type() {
        this.keyList = [];
        this.valueList = [];
      },
      selectedValueList() {
        this.valueList = this.selectedValueList;
      },
      selectedKeyList() {
        this.keyList = this.selectedKeyList;
      },
    },
    methods: {
      handleItemStyle(key) {
        return this.keyList.includes(key);
      },
      handleGridItem(key, value) {
        if (this.handleItemStyle(key)) {
          const keyIndex = this.keyList.findIndex(item => item === key);
          this.keyList.splice(keyIndex, 1);

          const valueIndex = this.valueList.findIndex(item => item === key);
          this.valueList.splice(valueIndex, 1);
          return;
        }
        if (this.keyList.length >= this.max) {
          this.$toast(`你只能选择${this.max}个兴趣哦`);
          return;
        }
        this.keyList.push(key);
        this.valueList.push(value);
      },
      handleSubmit() {
        if (this.keyList.length === 0) return;
        const data = {
          keyList: this.keyList,
          valueList: this.valueList,
          type: this.type,
        };
        this.$emit('selectInfo', data);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .survey-grid-select-component {
    padding: 90px 25px 0 45px;
  }

  .header {
    padding-bottom: 60px;
    display: flex;
    align-items: flex-end;
  }

  .title {
    margin-right: @size-small;
    font-size: @font-size-extra-large;
    color: @color-text-base;
    font-weight: @font-weight-bold;
    line-height: 1;
  }

  .desc {
    color: @color-text-lighter;
    font-size: @font-size-small;
    line-height: 1;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
  }

  .item {
    width: 150px;
    height: 60px;
    margin: 0 @size-small @size-base 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: @border-width-base @border-style-base @color-gray-light;
    box-sizing: border-box;
    border-radius: 30px;
    font-size: @font-size-base;
    color: @color-text-light;
    &.active {
      background: @color-primary-lighter;
      border: @border-width-base @border-style-base @color-primary-aide;
      color: @color-primary-aide;
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 0;
    padding: @size-medium;
  }

</style>
